<template>

<div class="bg-body-tertiary absoluteFlexCenter d-flex flex-column" translate="no">
  <div id="liff" class="bg-white flex-1 d-flex flex-column mx-auto">
    <div class="bg-white flex-1 flex-column flexCenter">

        <!-- content -->
        <div class="flex-1 w-100 bg-white d-flex flex-column" id="main">

          <div v-if="tabTitle == '總覽'" class="d-flex flex-column w-100 flex-1">
            <Dashboard />
          </div>

          <div v-if="tabTitle == '訂單管理'" class="d-flex flex-column w-100 flex-1">
          <!-- header -->
          <div class="position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 bg-white">
            <div v-if="!check_if_client()" class="h-header w-100 d-flex align-items-center ps-4 pe-3">
              <header class="flex-grow-1 fs-6 text-muted d-flex align-items-center">
                <b>訂單管理</b>
              </header>
              <button :disabled="isLoading || lists.length === 0"
                v-if="lists.length > 0 && !check_if_client()"
                class="btn btn-outline-primary rounded-pill py-1 px-2 lh-1 d-flex align-items-center" @click="exportOrderSummary()">
                  <svg class="mx-1" width="22" height="22"><use xlink:href="#table-export"/></svg>
                  <small class="me-2">匯出訂單</small>
              </button>
            </div>
            <!-- filter -->
            <div v-if="totalUserRecords !== 0" class="h-header w-100 px-3"
            :class="{'hideTitle': check_if_client()}">

              <div class="date-form d-flex align-items-center">
                <!-- Date Picker -->
                <VueDatePicker 
                  ref="datePicker" 
                  v-model="dateValue"
                  :year-picker="datePickerType === 'year'"
                  :quarter-picker="datePickerType === 'quarter'"
                  :range="datePickerType === 'date'"
                  :enable-time-picker="false"
                  :format="getDateFormat()"
                  @update:model-value="handleDateUpdate"
                >
                  <template #trigger>
                    <div class="btn-group border-0">
                      <div class="dateTrigger text-secondary">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16" fill="currentColor" aria-hidden="true">
                          <path d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"></path><path d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path><path d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path><path d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"></path>
                        </svg>
                      </div>
                      <!-- 動態切換日期選擇器類型 -->
                      <button class="btn rounded-0 btn-outline-secondary" :class="{'active': datePickerType === 'quarter'}" @click="setPickerType('quarter')"><small>季度</small></button>
                      <button class="btn rounded-0 btn-outline-secondary" :class="{'active': datePickerType === 'year'}" @click="setPickerType('year')"><small>年度</small></button>
                      <button class="btn rounded-0 btn-outline-secondary" :class="{'active': datePickerType === 'date'}" @click="setPickerType('date')"><small>日期</small></button>
                    </div>
                  </template>
                  <template #quarter="{ value }">
                    <span>{{ formatQuarter(value) }}</span>
                  </template>
                </VueDatePicker>
                <span class="ps-2 small overflow-x-auto text-nowrap">{{ selectedDateRange }}</span>
                <!-- close button -->
                <span v-if="!isLoading && selectedDateRange != '（不限時間）'" @click="clearDate" class="close-icon pe-1 text-black-30">
                  <svg width="20" height="20"><use xlink:href="#close-circle"/></svg>
                </span>
              </div>
            </div>

            <!-- new search filter -->
            <div v-if="totalUserRecords !== 0" class="h-header w-100 overflew-hidden px-3">
              <div class="w-100 d-flex align-items-center position-relative">
                <!-- search bar -->
                <div class="rounded-2 search w-100 py-2 d-flex align-items-center">
                  <!-- search icon -->
                  <span @click="handleSearch()" class="search-icon ps-1 text-secondary"><svg width="16" height="16"><use xlink:href="#search"/></svg></span>

                  <!-- input chips -->
                  <div v-if="chips.length" class="d-flex align-items-center me-2">
                    <span v-if="chips.includes('notArrived')" role="button" tabindex="0" @click="closeChip('notArrived')"
                      class="badge rounded-pill warning-mix-black-40 bg-tertiary-mix-white-40">
                      <svg class="bi pe-none me-1" width="14" height="14"><use xlink:href="#truck"/></svg>未到貨
                      <svg class="p-1 me-n1 opacity-50" width="16" height="16"><use xlink:href="#close"/></svg>
                    </span>
                    <span v-if="chips.includes('notPaid')" role="button" tabindex="0" @click="closeChip('notPaid')"
                      class="badge rounded-pill danger-mix-black-20 bg-danger-subtle">
                      <svg class="bi pe-none me-1" width="14" height="14"><use xlink:href="#pay"/></svg>未付款
                      <svg class="p-1 me-n1 opacity-50" width="16" height="16"><use xlink:href="#close"/></svg>
                    </span>
                    <span v-if="chips.includes('ibv')" role="button" tabindex="0" @click="closeChip('ibv')"
                      class="badge rounded-pill text-white bg-warning">IBV
                      <svg class="p-1 me-n1 opacity-50" width="16" height="16"><use xlink:href="#close"/></svg>
                    </span>
                    <span v-if="chips.includes('bv')" role="button" tabindex="0" @click="closeChip('bv')"
                      class="badge rounded-pill text-white bg-info">BV
                      <svg class="p-1 me-n1 opacity-50" width="16" height="16"><use xlink:href="#close"/></svg>
                    </span>
                  </div>

                  <!-- keyword input -->
                  <input
                    ref="searchInput"
                    :disabled="isLoading"
                    @input="debounceSearch"
                    @keydown="handleKeydown"
                    v-model.trim="query"
                    class="search-input w-100" id="search" placeholder="搜尋" 
                    @focus="showChips" 
                    @blur="hideChips"
                    type="search"
                    enterkeyhint="search"/>
                  <!-- close button -->
                  <span 
                    v-if="query || chips.length" 
                    @click="clearSearch()" 
                    class="close-icon pe-1 text-black-30">
                    <svg width="20" height="20"><use xlink:href="#close-circle"/></svg>
                  </span>
                </div>

                <!-- chips container -->
                <div v-if="showChipsContainer && chips.length < 4" class="chips d-flex align-items-center w-100 rounded-3 bg-white position-absolute top-101 start-0 z-20 shadow-sm">
                  <small v-if="!chips.includes('notArrived')" role="button" tabindex="0" @click="addChip('notArrived')"
                    class="rounded-pill flexCenter warning-mix-black-40 bg-tertiary-mix-white-40">
                    <svg class="bi pe-none me-1" width="15" height="15"><use xlink:href="#truck"/></svg>未到貨
                  </small>
                  <small v-if="!chips.includes('notPaid')" role="button" tabindex="0" @click="addChip('notPaid')"
                    class="rounded-pill flexCenter danger-mix-black-20 bg-danger-subtle">
                    <svg class="bi pe-none me-1" width="15" height="15"><use xlink:href="#pay"/></svg>未付款
                  </small>
                  <small v-if="!chips.includes('ibv')" role="button" tabindex="0" @click="addChip('ibv')"
                    class="rounded-pill flexCenter text-white bg-warning">IBV
                  </small>
                  <small v-if="!chips.includes('bv')" role="button" tabindex="0" @click="addChip('bv')"
                    class="rounded-pill flexCenter text-white bg-info">BV
                  </small>
                </div>
              </div>
            </div>

            <!-- pagination -->
            <!-- <div class="w-100 d-flex justify-content-center my-2">
              <button type="button" disabled class="opacity-25 btn btn-dark-light btn-pagin border-0 p-0 mx-2 d-flex flexCenter rounded-circle">
                <svg class="bi pe-none" width="21" height="21"><use xlink:href="#back"/></svg>
              </button>
              <button type="button" v-for="(index) in 5" :key="index" class="btn btn-dark-light btn-pagin border-0 fs-6 p-0 mx-2 d-flex flexCenter rounded-circle">
                {{ index+0 }}
              </button>
              <div class="btn-pagin fs-6 mx-2 d-flex flexCenter text-dark">
                ...
              </div>
              <button type="button" class="btn btn-dark-light btn-pagin border-0 p-0 mx-2 d-flex flexCenter rounded-circle">
                <svg class="bi pe-none" width="21" height="21"><use xlink:href="#forward"/></svg>
              </button>
            </div> -->

          </div>

          <!-- loading spinner -->
          <div v-if="isLoading" class="absoluteFlexCenter">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          
          <!-- floating action button -->
          <!-- <div v-if="lists.length !== 0" class="position-fixed w-100 mw-640 mx-auto bottom-92 z-20 pe-none">
            <div class="fab-container pe-auto">
              <button :disabled="isLoading" @touchstart="restSlide" @click="openModal('control')" class="btn fab btn-primary">
                <div class="fab-content text-white">
                  <svg width="28" height="28"><use xlink:href="#add"/></svg>
                </div>
              </button>
            </div>
          </div> -->
          
          <!-- floating action button -->
          <transition><div v-show="isToggled" class="modal-backdrop bg-black-50 z-20" @click="isToggled = false"></div></transition>
          <div v-show="subscriptionStatusLoaded && (hasActiveSubscription || orderQuota.usage_percentage < 100)" class="position-fixed w-100 min-vh-100 mw-640 mx-auto bottom-92 z-20 pe-none">
            <div class="fab-container pe-auto" @click="isToggled = !isToggled" :class="{ 'expanded': isToggled }">
              <button :disabled="isLoading" @touchstart="restSlide" class="btn fab btn-primary">
                <div class="fab-content text-white">
                  <svg width="28" height="28"><use xlink:href="#add"/></svg>
                </div>
              </button>
              <div @click="openModal('order')" class="sub-button btn btn-light">
                <svg width="28" height="28"><use xlink:href="#add"/></svg>
                <div class="btn-content a"></div>
              </div>
              <div @click="openModal('uploadFile')" class="sub-button btn btn-light">
                <svg width="24" height="24"><use xlink:href="#file-import"/></svg>
                <div class="btn-content b"></div>
              </div>
              <div @click="openModal('uploadCloud')" class="sub-button btn btn-light">
                <svg width="24" height="24"><use xlink:href="#cloud-import"/></svg>
                <div class="btn-content c"></div>
              </div>
            </div>
          </div>

          <!-- control modal -->
          <div ref="controlModalRef" class="modal fade" id="controlModal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="controlModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-control my-0 mx-auto" role="document">
              <div class="modal-content border-0 shadow">
                <div class="d-flex align-items-center justify-content-evenly">

                  <button @click="openModal('order')" class="btn btn-link">
                    <svg class="mt-1" width="28" height="28"><use xlink:href="#add"/></svg>
                    <div class="my-1 fw-medium small">單筆新增</div>
                  </button>

                  <button @click="openModal('uploadFile')" class="btn btn-link">
                    <svg class="mt-1" width="28" height="28"><use xlink:href="#file-import"/></svg>
                    <div class="my-1 fw-medium small">從檔案匯入</div>
                  </button>

                  <button @click="openModal('uploadCloud')" class="btn btn-link">
                    <svg class="mt-1" width="28" height="28"><use xlink:href="#cloud-import"/></svg>
                    <div class="my-1 fw-medium small">從雲端匯入</div>
                  </button>
                </div>
              </div>
            </div>
          </div>

            <!-- main -->
            <main v-show="!isLoading" class="position-fixed top-0 bottom-0 start-50 translate-middle-x mw-640 d-flex flex-column w-100 flex-1"
            :class="{'hideTitle': check_if_client()}">

              <div v-if="!hasActiveSubscription" role="alert" class="alert bg-primary p-0 mb-2 small lh-1 d-flex align-items-center justify-content-between alert-dismissible fade show rounded-0">
                <router-link class="p-3 flex-fill text-white" to="/plan"><b>立即訂閱！讓每一筆現金回饋與IBV點數一目了然💵💵</b></router-link>
                <button class="btn border-0 p-2 m-n1 lh-1 text-white opacity-75" type="button" data-bs-dismiss="alert" aria-label="Close">
                  <svg width="28" height="28"><use xlink:href="#close-lg"/></svg>
                </button>
              </div>

                <!-- no data -->
                <div v-if="totalUserRecords === 0" class="flex-1 p-4 flexCenter">
                  <div class="w-100 text-center">

                    <h6 class="mb-4 text-secondary opacity-75">尚未記錄任何訂單</h6>

                    <div class="w-100 d-flex align-items-center justify-content-evenly">
                      <button @click="openModal('order')" class="btn btn-link link-secondary link-opacity-75">
                        <svg class="mt-1" width="36" height="36"><use xlink:href="#add"/></svg>
                        <div class="my-2 fw-medium small">單筆新增</div>
                      </button>

                      <button @click="openModal('uploadFile')" class="btn btn-link link-secondary link-opacity-75">
                        <svg class="mt-1" width="36" height="36"><use xlink:href="#file-import"/></svg>
                        <div class="my-2 fw-medium small">從檔案匯入</div>
                      </button>

                      <button @click="openModal('uploadCloud')" class="btn btn-link link-secondary link-opacity-75">
                        <svg class="mt-1" width="36" height="36"><use xlink:href="#cloud-import"/></svg>
                        <div class="my-2 fw-medium small">從雲端匯入</div>
                      </button>
                    </div>

                  </div>
                </div>

                <!-- No search results -->
                <div v-else-if="totalUserRecords > 0 && lists.length === 0" class="flex-1 p-4 flexCenter">
                  <div v-if="!isLoading" class="w-100 text-center">
                    <h6 class="text-muted">沒有符合的資料</h6>
                    <small>請確認關鍵字或日期範圍並再試一次。</small>
                  </div>
                </div>


                <virtual-list v-else
                  ref="virtualListRef"
                  :data-key="'Id'"
                  :data-sources="processedList"
                  :data-component="listItemComponent"
                  :keeps="20"
                  :estimate-size="120.5"
                  style="overflow-y: auto; max-height: 100vh;"
                  @scroll="loadMore"
                />

                <div v-if="isLoadingMore" class="text-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

            </main>
          </div>

          <div v-if="tabTitle == '分析報告'" class="d-flex flex-column w-100 flex-1">
            <Statistics :main-date="date" :has-active-subscription="hasActiveSubscription" @update:main-date="updateMainDate"/>
          </div>

          <div v-if="tabTitle == '會員資訊'" class="d-flex flex-column w-100 flex-1">
            <User :user-id="userId" :token="token" :has-subscription-history="hasSubscriptionHistory" />
          </div>

          <div v-if="tabTitle == '更多'" class="d-flex flex-column w-100 flex-1">
            <Setting />
          </div>


          <!-- footer -->
          <div class="position-fixed bottom-0 start-50 translate-middle-x w-100 mw-640 z-3">
            <footer class="w-100">
              <div class="bg-white d-flex align-items-center justify-content-evenly">
                
                <!-- <div class="tab-btn">
                  <div
                    @touchstart="rippleEffect"
                    @click="tabTitle='總覽'"
                    class="py-2 w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center small text-dark"
                    href="#"
                    :class="{'active': tabTitle == '總覽'}"
                  >
                    <svg v-if="tabTitle == '總覽'" class="mt-1" width="24" height="24"><use xlink:href="#home-active"/></svg>
                    <svg v-else class="mt-1" width="24" height="24"><use xlink:href="#home"/></svg>
                    <div class="my-1 text-center">總覽</div>
                  </div>
                </div> -->
                <div class="tab-btn">
                  <div
                    @touchstart="rippleEffect"
                    @click="changeTab('訂單管理')"
                    class="py-2 w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center small text-dark"
                    href="#"
                    :class="{'active': tabTitle == '訂單管理'}"
                  >
                    <svg v-if="tabTitle == '訂單管理'" class="mt-1" width="24" height="24"><use xlink:href="#list-active"/></svg>
                    <svg v-else class="mt-1" width="24" height="24"><use xlink:href="#list"/></svg>
                    <div class="my-1 text-center">訂單</div>
                  </div>
                </div>
                <div class="tab-btn">
                  <div
                    @touchstart="rippleEffect"
                    @click="changeTab('分析報告')"
                    class="py-2 w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center small text-dark"
                    href="#"
                    :class="{'active': tabTitle == '分析報告'}"
                  >
                    <svg v-if="tabTitle == '分析報告'" class="mt-1" width="24" height="24"><use xlink:href="#chart-active"/></svg>
                    <svg v-else class="mt-1" width="24" height="24"><use xlink:href="#chart"/></svg>
                    <div class="my-1 text-center">分析</div>
                  </div>
                </div>
                <div class="tab-btn">
                  <div
                    @touchstart="rippleEffect"
                    @click="changeTab('會員資訊')"
                    class="py-2 w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center small text-dark"
                    href="#"
                    :class="{'active': tabTitle == '會員資訊'}"
                  >
                    <svg v-if="tabTitle == '會員資訊'" class="mt-1" width="24" height="24"><use xlink:href="#customer-active"/></svg>
                    <svg v-else class="mt-1" width="24" height="24"><use xlink:href="#customer"/></svg>
                    <div class="my-1 text-center position-relative">
                      會員
                      <span
                        class="new rounded-pill bg-danger text-white position-absolute flexCenter z-20">
                        <b>NEW</b>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 
                <div class="tab-btn">
                  <div
                    @touchstart="rippleEffect"
                    @click="tabTitle='更多'"
                    class="py-2 w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center small text-dark"
                    href="#"
                    :class="{'active': tabTitle == '更多'}"
                  >
                    <svg v-if="tabTitle == '更多'" class="mt-1" width="24" height="24"><use xlink:href="#more-active"/></svg>
                    <svg v-else class="mt-1" width="24" height="24"><use xlink:href="#more"/></svg>
                    <div class="my-1 text-center">更多</div>
                  </div>
                </div> -->

              </div>
            </footer>
          </div>


        </div>
    </div>
  </div>
</div>

<!-- confirm modal -->
<div ref="confirmModalRef" class="modal fade" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered mx-auto" role="document">
    <div class="modal-content border-0 shadow">
      <div class="modal-body p-4 text-center">
        <span class="fw-medium" id="confirmModalLabel">列表內已有資料，需要覆蓋嗎？</span>
      </div>
      <div class="modal-footer flex-nowrap p-0">
        <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 border-end" data-bs-dismiss="modal"
        @click="handleOverwrite(false), closeModal">新增資料</button>
        <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0" data-bs-dismiss="modal"
        @click="handleOverwrite(true), closeModal">全部覆蓋</button>
      </div>
    </div>
  </div>
</div>

<!-- delete confirm modal -->
<div ref="confirDelModalRef" class="modal fade" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered mx-auto" role="document">
    <div class="modal-content border-0 shadow">
      <div class="modal-body p-4 text-center">
        <span class="fw-medium" id="confirmModalLabel">確定要刪除該筆資料嗎？</span>
      </div>
      <div class="modal-footer flex-nowrap p-0">
        <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 border-end" data-bs-dismiss="modal"
        @click="cancelDel">取消</button>
        <button type="button" class="btn btn-lg btn-link link-danger fs-6 text-decoration-none col-6 py-3 m-0 rounded-0" data-bs-dismiss="modal"
        @click="confirmDel">刪除</button>
      </div>
    </div>
  </div>
</div>

  <!-- upload modal -->
  <div ref="cloudUploadRef" class="modal fade" id="uploadModal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered mx-auto" role="document">
      <div class="modal-content border-0 shadow">
        <div class="modal-body p-4 text-center">
          <span v-if="modalUpload === 'cloud'" class="fw-medium" id="uploadModalLabel">上傳 Google 雲端試算表</span>
          <span v-if="modalUpload === 'file'" class="fw-medium" id="uploadModalLabel">上傳訂單檔案</span>
          <!-- upload cloud file -->
          <div v-if="modalUpload === 'cloud'" class="form-floating mb-2">
            <input v-model="url" id="uploadCloud" type="text" class="form-control" placeholder="https://">
            <label for="uploadCloud">雲端文件連結</label>
          </div>
          <!-- <div v-if="modalUpload = 'cloud'" class="small text-end">
            <span class="text-muted">請輸入雲端文件連結</span>
            <span class="text-danger">請輸入正確的格式</span>
          </div> -->

          <!-- file upload -->
          <div v-if="modalUpload === 'file'" class="form-floating mb-2">
            <input type="file"
                    ref="fileInput"
                    @change="handleFiles"
                    accept=".xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    id="uploadFile" class="form-control">
            <!-- <label for="uploadFile">選擇檔案</label> -->
          </div>
          <ul v-if="modalUpload === 'cloud'" class="custom-ul small mt-3 text-start text-muted">
            <li>請將欲輸入的資料放在<b>第一分頁</b></li>
            <li>請開啟文件共用權限給「<b>知道連結的任何人</b>」<a href="https://reurl.cc/Y0yxDO" target="_blank" rel="noopener"><svg class="mb-1" width="18" height="18"><use xlink:href="#help-circle"/></svg></a></li>
          </ul>
          <ul v-if="modalUpload === 'file'" class="custom-ul small mt-3 text-start text-muted">
            <li>請將欲輸入的資料放在<b>第一分頁</b></li>
            <li>文件如有密碼，請先<b>解除密碼保護</b></li>
            <li>僅接受 excel 格式 (.xlsx .xls)</li>
          </ul>
        </div>
        <div v-if="modalUpload === 'cloud'" class="modal-footer flex-nowrap p-0">
          <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 border-end" data-bs-dismiss="modal"
          @click="closeModal">取消</button>
          <button :disabled="!url" type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0" data-bs-dismiss="modal"
            @click="handleCloudUpload"
          ><b>確定</b></button>
        </div>
      </div>
    </div>
  </div>

<!-- file upload -->
<!-- <input type="file"
        ref="fileInput"
        @change="handleFiles"
        accept=".xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        style="display: none;"> -->

<OrderModal ref="orderModalRef" 
  :order="selectedOrder" 
  :addr-list="addrList"
  :contacts="uniqueLatestContacts"
  :has-active-subscription="hasActiveSubscription"
  @add="addOrder"
  @update="updateOrder"
  @del="deleteOrder"
  @cancel="closeModal"
  @fetchAutoCompleteData="fetchAutoCompleteData"/>

<!-- Quota Alert Modal -->
<div 
  ref="quotaAlertModalRef" 
  class="modal fade" 
  id="quotaAlertModal" 
  data-bs-backdrop="static" 
  data-bs-keyboard="true" 
  tabindex="-1" 
  aria-labelledby="quotaAlertModalLabel" 
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-body p-4 small text-muted">
        <p class='fw-medium text-center fs-6 text-dark' id='quotaAlertModalLabel'>訂單額度已滿</p>
        <p>您的訂單數量已達到免費額度上限（50筆），但您仍可以：</p>
        <ul class="custom-ul mb-3">
          <li>📄 查看現有訂單</li>
          <li>📤 匯出訂單資料</li>
          <li>🗑️ 刪除不需要的訂單</li>
        </ul>
        <span>如需新增更多訂單，請考慮升級到進階方案。</span>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary text-white w-100 h-48"
          v-if="shouldShowUpgradeButton"
          @click="handleUpgradeClick"
        >
          <b>立即升級 💎</b>
        </button>
        <button class="btn btn-light w-100 h-48" aria-label="Close" data-bs-dismiss="modal"
        >稍後再說</button>
      </div>
    </div>
  </div>
</div>

</template>


<script>
import dayjs from 'dayjs';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import { Modal } from 'bootstrap';
import User from '@/components/UserCom.vue';
import Setting from '@/components/SettingCom.vue';
import Dashboard from '@/components/DashboardCom.vue';
import Statistics from '@/components/StatisticsCom.vue';
import OrderModal from '@/components/OrderModal.vue';
import liff from '@line/liff';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ListItem from '@/components/ListItem.vue';
import { emitter } from '@/utils/eventBus.js';
import { hasActiveSubscription as checkActiveSubscription } from '@/utils/setup.js';
import debounce from 'lodash.debounce';

let liff_callback = process.env.VUE_APP_LIFF_CALLBACK;
let api_url = process.env.VUE_APP_API_URL;

const page_size = 30;

export default {
  name: 'MainView',
  components: {
    User,
    Setting,
    Dashboard,
    Statistics,
    OrderModal,
    VueDatePicker
  },
  data () {
    return {
      isLoading: false,
      isMounted: false,
      modalUpload: null,
      // for list slide
      startX: 0,
      endX: 0,      
      startY: 0,
      endY: 0,

      lists: [],
      selectedFile: null,
      selectedOrder: {},
      tabTitle: '訂單管理',
      orderModalType: 'add',
      slideIndex: -1,
      url: null,
      query: '',
      refreshTokenInterval: null,
      subscriptionCheckInterval: null,
      handleVisibilityChange: null,
      scrollIndex: 0,
      scrollOffset: 0,
      isToggled: '',
      showChipsContainer: false,
      chips: [],
      date: null,
      totalItems: 0,
      pageSize: page_size,
      isLoadingMore: false,
      currentSearchParams: {},
      totalUserRecords: -1,
      isClearing: false,
      debouncedSearch: null,
      datePickerType: 'quarter', // 預設為季度範圍
      dateValue: this.getCurrentQuarter(),
      selectedDateRange: '',

      // 訂單額度相關資料
      orderQuota: {
        total_orders: 0,
        quota_limit: 50,
        quota_used: 0,
        quota_remaining: 50,
        quota_exceeded: false,
        usage_percentage: 0
      },

      // 用戶是否有訂閱記錄
      hasSubscriptionHistory: false,

      // 用戶當前訂閱狀態
      subscriptionStatus: null,

      // 訂閱狀態是否已載入完成
      subscriptionStatusLoaded: false,

      // 額度警示相關
      quotaAlertHtml: '',
      shouldShowUpgradeButton: false
    }
  },
  watch: {
    tabTitle() {
      /* this.clearSearch();
      this.date = null;
      this.$nextTick(() => {
        const element = document.getElementById('liff');
        if (element) {
          element.scrollTop = 0;
        }
      }); */
    },
    /* date: {
      handler(newValue) {
        console.log('MainView date changed:', newValue); // 添加日誌
        this.handleDateFilter();
      },
      deep: true
    }, */
    query() {
      this.checkAndReload();
    },
    chips: {
      handler() {
        this.checkAndReload();
      },
      deep: true
    },
    datePickerType: {
      handler(newType) {
        
        // Then handle value changes
        this.$nextTick(() => {
          if (newType === 'date') {
            this.dateValue = [];
          } else if (newType === 'year') {
            this.dateValue = new Date().getFullYear();
          } else if (newType === 'quarter') {
            this.dateValue = this.getCurrentQuarter();
          }
        });
      }
    },

  },
  setup() {
    const cloudUploadRef = ref(null);
    let cloudUploadInstance = null;
    const confirmModalRef = ref(null);
    let confirmModalInstance = null;
    const confirDelModalRef = ref(null);
    let confirDelModalInstance = null;
    const controlModalRef = ref(null);
    let controlModalInstance = null;
    const quotaAlertModalRef = ref(null);
    let quotaAlertModalInstance = null;
    let uniqueLatestContacts = ref([]);
    let addrList = ref([]);
    const listItemComponent = ListItem;

    onMounted(() => {
      if (cloudUploadRef.value) {
        cloudUploadInstance = new Modal(cloudUploadRef.value);
      } else {
        console.log("cloudUploadInstance instance can't be initialized.");
      }

      if (confirmModalRef.value) {
        confirmModalInstance = new Modal(confirmModalRef.value);
      } else {
        console.log("confirModalInstance instance can't be initialized.");
      }

      if (confirDelModalRef.value) {
        confirDelModalInstance = new Modal(confirDelModalRef.value);
      } else {
        console.log("confirDelModalInstance instance can't be initialized.");
      }

      if (controlModalRef.value) {
        controlModalInstance = new Modal(controlModalRef.value);
      } else {
        console.log("controlModalInstance instance can't be initialized.");
      }

      // 初始化 Quota Alert Modal
      if (quotaAlertModalRef.value) {
        quotaAlertModalInstance = new Modal(quotaAlertModalRef.value);
      } else {
        console.log("quotaAlertModalInstance instance can't be initialized.");
      }
    
    });

    onUnmounted(() => {
      // Cleanup the modal instances carefully
      try {
        if (cloudUploadInstance) {
          cloudUploadInstance.dispose();
          cloudUploadInstance = null;
        }
      } catch (e) {
        console.error('Error disposing cloudUploadInstance:', e);
      }
      
      try {
        if (confirmModalInstance) {
          confirmModalInstance.dispose();
          confirmModalInstance = null;
        }
      } catch (e) {
        console.error('Error disposing confirmModalInstance:', e);
      }
      
      try {
        if (confirDelModalInstance) {
          confirDelModalInstance.dispose();
          confirDelModalInstance = null;
        }
      } catch (e) {
        console.error('Error disposing confirDelModalInstance:', e);
      }
      
      try {
        if (controlModalInstance) {
          controlModalInstance.dispose();
          controlModalInstance = null;
        }
      } catch (e) {
        console.error('Error disposing controlModalInstance:', e);
      }
      
      try {
        if (quotaAlertModalInstance) {
          quotaAlertModalInstance.dispose();
          quotaAlertModalInstance = null;
        }
      } catch (e) {
        console.error('Error disposing quotaAlertModalInstance:', e);
      }
    });

    const showCloudUpload = (isShow) => {
      if (isShow)
        cloudUploadInstance.show();
      else
        cloudUploadInstance.hide();
    }

    const showConfirm = (isShow) => {
      if (isShow)
        confirmModalInstance.show();
      else
        confirmModalInstance.hide();
    }

    const showDelConfirm = (isShow) => {
      if (isShow)
        confirDelModalInstance.show();
      else
        confirDelModalInstance.hide();
    }

    const showControl = (isShow) => {
      if (isShow)
        controlModalInstance.show();
      else
        controlModalInstance.hide();
    }

    const showQuotaAlertModal = (isShow) => {
      try {
        if (isShow && quotaAlertModalInstance) {
          quotaAlertModalInstance.show();
        } else if (!isShow && quotaAlertModalInstance) {
          quotaAlertModalInstance.hide();
        }
      } catch (error) {
        console.error('Error toggling quota alert modal:', error);
      }
    }
    
    return {
      showCloudUpload,
      showConfirm,
      cloudUploadRef,
      confirmModalRef,
      confirDelModalRef,
      showDelConfirm,
      controlModalRef,
      showControl,
      quotaAlertModalRef,
      showQuotaAlertModal,
      uniqueLatestContacts,
      addrList,
      listItemComponent
    }
  },
  computed: {
    ...mapGetters(['token', 'refresh_token', 'userId', 'name']),

    // sanitized HTML for quota alert (safe subset)
    sanitizedQuotaAlertHtml() {
      return this.sanitizeHtml(this.quotaAlertHtml || '');
    },

    // 判斷用戶是否有有效訂閱
    hasActiveSubscription() {
      return checkActiveSubscription(this.subscriptionStatus);
    },

    processedList() {
      // 檢查是否為未訂閱且超額狀態
      const isFreeUser = !this.subscriptionStatus || 
                        this.subscriptionStatus.main === 'Pending Activation' || 
                        this.subscriptionStatus.main === 'Expired';
      const isQuotaExceeded = this.orderQuota && this.orderQuota.quota_exceeded;
      // 檢查是否已達到或超過 50 筆限制
      const isAtOrOverLimit = isFreeUser && this.orderQuota && this.orderQuota.total_orders >= 50;
      
      return this.lists.map((item, index, array) => {
        return {
          ...item,
          previousDate: index > 0 ? array[index - 1].Date : null,
          // 未訂閱且超額：所有訂單都不能複製，但前50筆可編輯，超過50筆只能查看
          isReadOnly: isFreeUser && isQuotaExceeded && index >= 50, // 超過50筆的訂單為唯讀
          cannotCopy: isAtOrOverLimit // 達到或超過 50 筆就不能複製
        };
      });
    },

    formatDateRange() {
      if (!this.dateValue) return '';
      
      switch(this.datePickerType) {
        case 'quarter': {
          const quarterDate = dayjs(this.dateValue).startOf('quarter');
          const startMonth = quarterDate.format('M');
          const endMonth = quarterDate.add(2, 'month').format('M');
          return `${quarterDate.format('YYYY')}/${startMonth}~${endMonth}月`;
        }
        case 'year': {
          return `${this.dateValue}年`;
        }
        case 'date': {
          if (Array.isArray(this.dateValue)) {
            const [start, end] = this.dateValue;
            return `${dayjs(start).format('YYYY/MM/DD')}~${dayjs(end).format('YYYY/MM/DD')}`;
          }
          return '';
        }
        default:
          return '';
      }
    }
  },
  async mounted() {

    const tab = this.$route.query.tab;

    // 阻止外部滾動
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    emitter.on('openModal', e => this.openModal(e.type, e.data, e.index));
    emitter.on('updateState', (data) => {
      this.updateOrder(data);
    });
    emitter.on('showQuotaAlert', () => {
      this.showQuotaExceededAlert(true);
    });

    if (this.userId) {
      // 先檢查訂閱狀態，避免會員 tab 延遲顯示
      await this.checkSubscriptionHistory(); // 檢查是否有訂閱記錄
      await this.getOrderQuota(); // 取得訂單額度資訊
      
      // 設置初始日期值但不觸發過濾
      this.dateValue = this.getCurrentQuarter();
      this.selectedDateRange = this.formatDateRange;
      
      // 設置日期範圍以供統計組件使用
      const quarterDate = dayjs(this.dateValue).startOf('quarter');
      this.date = [
        quarterDate.toDate(),
        quarterDate.add(2, 'month').endOf('month').toDate()
      ];
      
      // 設置初始搜尋參數
      this.currentSearchParams = {
        start_date: quarterDate.format('YYYY-MM-DD'),
        end_date: quarterDate.add(2, 'month').endOf('month').format('YYYY-MM-DD'),
        search: ''
      };
      
      // 最後載入訂單資料（已包含日期過濾）
      await this.get_orders(0, this.pageSize, this.currentSearchParams);
      
      this.isMounted = true;

      // 檢查是否需要顯示額度超過提示
      if (this.$route.query.quota_exceeded === 'true') {
        this.showQuotaExceededAlert();
      }

      // 每 3 分鐘更新 token
      this.refreshTokenInterval = setInterval(async () => {
        await this.refreshToken();
      }, 3 * 60 * 1000);

      // 每 5 分鐘檢查訂閱狀態（避免過期後仍能使用）
      this.subscriptionCheckInterval = setInterval(async () => {
        await this.recheckSubscriptionStatus();
      }, 5 * 60 * 1000);

      // 監聽視窗切換事件，切回頁面時重新檢查訂閱狀態和額度
      this.handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
          console.log('頁面切換回來，重新檢查訂閱狀態和額度...');
          await this.recheckSubscriptionStatus();
          await this.getOrderQuota();
          
          // 如果是免費用戶且訂單達到 50 筆，顯示警示
          const isFreeUser = !this.subscriptionStatus || 
                            this.subscriptionStatus.main === 'Pending Activation' || 
                            this.subscriptionStatus.main === 'Expired';
          
          if (isFreeUser && this.orderQuota.total_orders >= 50) {
            this.showQuotaExceededAlert();
          }
        }
      };
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if (tab) {
        this.tabTitle = tab;
      }

    }
    else {
      // 保留 tab 參數導向到登入頁面
      const tabParam = this.$route.query.tab;
      if (tabParam) {
        this.$router.push(`/me?tab=${encodeURIComponent(tabParam)}`);
      } else {
        this.$router.push('/me');
      }
      return;
    }
    
  },
  beforeUnmount() {
    // 恢復外部滾動
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';

    // 解除自動更新 token
    clearInterval(this.refreshTokenInterval);
    
    // 解除訂閱狀態檢查
    clearInterval(this.subscriptionCheckInterval);

    // 移除視窗切換事件監聽
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    emitter.off('openModal');
    emitter.off('updateState');
    emitter.off('showQuotaAlert');
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 3000);
  },
  methods: {
    ...mapActions(['setToken']),

    handleUpgradeClick() {
      // 使用 Bootstrap Modal API 安全地關閉 modal
      const modalElement = this.$refs.quotaAlertModalRef;
      
      if (!modalElement) {
        // 如果找不到 modal 元素，直接跳轉
        this.$router.push('/plan');
        return;
      }

      // 監聽 modal 完全關閉事件
      const handleHidden = () => {
        // 移除事件監聽器
        modalElement.removeEventListener('hidden.bs.modal', handleHidden);
        // modal 已完全關閉，安全跳轉
        this.$router.push('/plan');
      };
      
      // 註冊關閉完成事件
      modalElement.addEventListener('hidden.bs.modal', handleHidden, { once: true });
      
      // 關閉 modal
      try {
        this.showQuotaAlertModal(false);
      } catch (e) {
        console.error('Error hiding quota alert modal:', e);
        // 如果關閉失敗，移除監聽器並直接跳轉
        modalElement.removeEventListener('hidden.bs.modal', handleHidden);
        this.$router.push('/plan');
      }
    },

    changeTab(tab) {
      this.tabTitle = tab;
      this.$router.push({ path: '/main', query: { tab } });
    },
    
    setPickerType(type) {
      // Direct DOM interaction for immediate response
      if (this.$refs.datePicker) {
        const picker = this.$refs.datePicker;
        picker.closeMenu();
        this.datePickerType = type;
        
        // Force immediate state update
        this.$nextTick(() => {
          picker.$el.click();
        });
      }
    },

    getCurrentQuarter() {
      const now = dayjs()
      const currentQuarter = Math.floor(now.month() / 3);
      const quarterStartMonth = currentQuarter * 3;
      
      return now
        .month(quarterStartMonth)  // Set to first month of quarter
        .startOf('month')         // Set to first day of month
        .startOf('day')          // Set to beginning of day
        .toDate();               // Convert to JavaScript Date object
    },

    // Basic sanitizer: keep only a small whitelist of tags and attributes
    sanitizeHtml(rawHtml) {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${rawHtml}</div>`, 'text/html');
        const whitelist = ['B','STRONG','I','EM','P','BR','UL','OL','LI','H1','H2','H3','HR','A','STRIKE'];

        const cleanNode = (node) => {
          // If text node, keep text
          if (node.nodeType === Node.TEXT_NODE) return document.createTextNode(node.nodeValue);
          if (node.nodeType !== Node.ELEMENT_NODE) return null;

          const tag = node.tagName.toUpperCase();
          if (!whitelist.includes(tag)) {
            // unwrap children
            const fragment = document.createDocumentFragment();
            node.childNodes.forEach(child => {
              const cn = cleanNode(child);
              if (cn) fragment.appendChild(cn);
            });
            return fragment;
          }

          const el = document.createElement(tag.toLowerCase());
          // copy allowed attributes (only href for anchors)
          if (tag === 'A' && node.getAttribute('href')) {
            el.setAttribute('href', node.getAttribute('href'));
            el.setAttribute('target', '_blank');
            el.setAttribute('rel', 'noopener noreferrer');
          }

          node.childNodes.forEach(child => {
            const cn = cleanNode(child);
            if (cn) el.appendChild(cn);
          });
          return el;
        };

        const wrapper = doc.body.firstElementChild; // the <div> wrapper
        const out = document.createElement('div');
        wrapper.childNodes.forEach(child => {
          const c = cleanNode(child);
          if (c) out.appendChild(c);
        });
        return out.innerHTML;
      } catch (e) {
        console.error('sanitizeHtml error', e);
        return '';
      }
    },
    formatQuarter(value) {
      const quarterNum = Math.floor(value.getMonth() / 3);
      const startMonth = quarterNum * 3 + 1;
      const endMonth = startMonth + 2;
      
      return `${startMonth}~${endMonth}月`;
    },

    handleDateUpdate(newValue) {
      this.dateValue = newValue;
      // Update the display value only when user confirms selection
      this.selectedDateRange = this.formatDateRange;

      // Set date for Statistics component synchronization
      if (Array.isArray(newValue)) {
        this.date = newValue;
      } else if (this.datePickerType === 'year') {
        const yearDate = dayjs().year(newValue);
        this.date = [
          yearDate.startOf('year').toDate(),
          yearDate.endOf('year').toDate()
        ];
      } else if (this.datePickerType === 'quarter') {
        const quarterDate = dayjs(newValue).startOf('quarter');
        this.date = [
          quarterDate.toDate(),
          quarterDate.add(2, 'month').endOf('month').toDate()
        ];
      }

      this.handleDateFilter();
    },

    getAdjacentSource(index) {
      return index > 0 ? this.lists[index - 1] : null;
    },

    async refreshToken() {

      try {
        const baseURL = `${api_url}/v1/user/refresh/${this.userId}`;

        const response = await axios.get(baseURL, {
          headers: {
            'Authorization': `Bearer ${this.refresh_token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        if (response.data.result == "OK") {
          this.setToken(response.data.token);
          return true;
        } else {
          console.log('refreshToken not OK');
          liff.logout();
          setTimeout(() => {
            liff.login({ redirectUri: `${liff_callback}?page=${this.$route.query.page}` }); 
          }, 500);
          return false;
        }
      } catch (error) {
        console.error('Error refresh token:', error);
        liff.logout();
        setTimeout(() => {
          liff.login({ redirectUri: `${liff_callback}?page=${this.$route.query.page}` }); 
        }, 500);
        return false;
      }
    },

    resetVirtualList() {
      this.$nextTick(() => {
        if (this.$refs.virtualListRef) {
          this.$refs.virtualListRef.scrollToIndex(0);
        }
      });
    },

    // 取得額度顯示的CSS class
    getQuotaBadgeClass() {
      if (this.orderQuota.quota_exceeded) {
        return 'text-danger bg-danger bg-opacity-10 border border-danger';
      } else if (this.orderQuota.usage_percentage >= 80) {
        return 'text-warning bg-warning bg-opacity-10 border border-warning';
      } else {
        return 'text-success bg-success bg-opacity-10 border border-success';
      }
    },

    async getOrderQuota() {
      try {
        const response = await axios.get(`${api_url}/v1/users/${this.userId}/order_quota`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        this.orderQuota = response.data;
      } catch (error) {
        console.error('Error fetching order quota:', error);
      }
    },

    async checkSubscriptionHistory() {
      try {
        const response = await axios.get(`${api_url}/v1/users/${this.userId}/subscription`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        // 獲取訂閱狀態
        const statusResponse = await axios.get(`${api_url}/v1/users/${this.userId}/subscription_status`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        this.subscriptionStatus = statusResponse.data;

        // 如果有訂閱記錄或交易記錄，則顯示會員資訊 tab
        if (response.data && (response.data.subscription || (response.data.orders && response.data.orders.length > 0))) {
          this.hasSubscriptionHistory = true;
        } else {
          this.hasSubscriptionHistory = false;
          // 如果用戶當前在會員資訊 tab 但沒有訂閱記錄，切換到訂單管理 tab
          if (this.tabTitle === '會員資訊') {
            this.tabTitle = '訂單管理';
          }
        }

        // 標記訂閱狀態載入完成
        this.subscriptionStatusLoaded = true;

        // 如果訂閱狀態為 Active，清除額度警示記錄
        if (this.subscriptionStatus.main === 'Active') {
          console.log('訂閱狀態為 Active，清除額度警示記錄...');
          try {
            const quotaKey = `quota_alert_shown_${this.userId}`;
            localStorage.removeItem(quotaKey);
          } catch (e) {
            console.error('Error removing quota alert flag:', e);
          }
        }

        // 檢查是否為未訂閱狀態且訂單已達到或超過 50 筆
        const isFreeUser = this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        
        if (isFreeUser) {
          // 更新額度資訊
          await this.getOrderQuota();
          
          // 如果訂單數量達到或超過 50 筆，顯示額度提示
          if (this.orderQuota.total_orders >= 50) {
            console.log('檢測到未訂閱且訂單達到 50 筆，顯示額度提示...');
            this.showQuotaExceededAlert();
          }
        }
      } catch (error) {
        console.error('Error fetching subscription history:', error);
        // 如果 API 出錯，預設不顯示會員資訊 tab
        this.hasSubscriptionHistory = false;
        this.subscriptionStatus = null;
        if (this.tabTitle === '會員資訊') {
          this.tabTitle = '訂單管理';
        }
        // 即使出錯也要標記載入完成，避免卡在載入狀態
        this.subscriptionStatusLoaded = true;
      }
    },

    // 重新檢查訂閱狀態（用於定期檢查是否過期）
    async recheckSubscriptionStatus() {
      try {
        const statusResponse = await axios.get(`${api_url}/v1/users/${this.userId}/subscription_status`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        const newStatus = statusResponse.data;
        const oldStatus = this.subscriptionStatus;

        // 更新訂閱狀態
        this.subscriptionStatus = newStatus;

        // 如果訂閱狀態變為 Active（從任何狀態變為 Active，包括新訂閱或重新啟用）
        if (newStatus.main === 'Active' && oldStatus && oldStatus.main !== 'Active') {
          console.log('訂閱已啟用，清除額度警示記錄...');
          
          // 清除額度警示的 localStorage 記錄
          try {
            const quotaKey = `quota_alert_shown_${this.userId}`;
            localStorage.removeItem(quotaKey);
          } catch (e) {
            console.error('Error removing quota alert flag:', e);
          }
        }

        // 如果訂閱狀態從 Active 變為 Expired（取消訂閱或過期）
        if (oldStatus && oldStatus.main === 'Active' && newStatus.main === 'Expired') {
          console.log('訂閱已過期或取消，清除額度警示記錄並檢查訂單數量...');
          
          // 清除 localStorage，確保可以再次顯示額度警示
          try {
            const quotaKey = `quota_alert_shown_${this.userId}`;
            localStorage.removeItem(quotaKey);
          } catch (e) {
            console.error('Error removing quota alert flag:', e);
          }
          
          // 更新額度資訊
          await this.getOrderQuota();
          
          // 如果訂單數量達到或超過 50 筆，顯示額度提示（訂閱過期後重新檢查，強制顯示）
          if (this.orderQuota.total_orders >= 50) {
            this.showQuotaExceededAlert(true); // 強制顯示，因為狀態已改變
          }
          // 如果訂單在 50 筆以內，不做任何提示，用戶可以繼續使用
        }
        
        // 如果從任何有效狀態變為 Expired，更新額度資訊
        if (newStatus.main === 'Expired' && oldStatus && oldStatus.main !== 'Expired') {
          await this.getOrderQuota();
        }

      } catch (error) {
        console.error('Error rechecking subscription status:', error);
      }
    },

    async get_orders(offset = 0, limit = this.pageSize, searchParams = {}) {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        let baseURL = `${api_url}/v2/orders/${this.userId}`;
        const params = new URLSearchParams({
          offset: offset,
          limit: limit,
          ...searchParams
        });

        const response = await axios.get(`${baseURL}?${params}`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        const size = JSON.stringify(response.data).length;
        console.log(`Response size: ${size} bytes`);

        const { total, orders, totalUserRecords } = response.data;

        // 累加新的訂單到列表末尾
        this.lists = [...this.lists, ...orders];
        this.totalItems = total;
        this.totalUserRecords = totalUserRecords;

        // 如果是第一次載入或重新載入，更新訂單額度
        if (offset === 0) {
          await this.getOrderQuota();
        }

      } catch (error) {
        console.error('Error fetching orders:', error);
      } finally {
        this.isLoading = false;
        this.isLoadingMore = false;
      }
    },

    loadMore(event) {
      if (this.isLoading || this.lists.length >= this.totalItems) {
        return;
      }

      if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 20) {
        const nextOffset = this.lists.length;
        this.isLoadingMore = true;
        const limit = this.pageSize;
        
        // 計算當前窗口範圍
        const currentIndex = Math.floor(event.target.scrollTop / (event.target.scrollHeight / this.totalItems));
        const windowSize = 3 * this.pageSize;
        const endIndex = Math.min(this.totalItems, currentIndex + windowSize);

        // 如果需要更多數據，則獲取
        if (this.lists.length < endIndex) {
          const missingDataCount = Math.min(limit, endIndex - this.lists.length);
          this.get_orders(nextOffset, missingDataCount, this.currentSearchParams).then(() => {
          this.$nextTick(() => {
              const scrollElement = event.target;
              scrollElement.scrollTop = scrollElement.scrollTop - 1;
              setTimeout(() => {
                scrollElement.scrollTop = scrollElement.scrollTop + 1;
              }, 0);
            });
          });

        }
      }
    },

    updateAutoCompleteData(autoCompleteData) {
      // 實現更新自動完成數據的邏輯
      this.uniqueLatestContacts = autoCompleteData.contacts;
      this.addrList = autoCompleteData.addresses;
    },

    async fetchAutoCompleteData() {
      try {
        const response = await axios.get(`${api_url}/v2/auto-complete/${this.userId}`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });
        const { autoCompleteData } = response.data;
        this.updateAutoCompleteData(autoCompleteData);
      } catch (error) {
        console.error('Error fetching auto-complete data:', error);
      }
    },

    updateMainDate(newDate) {
      this.date = newDate;
      this.handleDateFilter();
    },

    handleDateFilter() {
      let startDate, endDate;
      let currentKeywords = this.currentSearchParams.search || '';

      switch(this.datePickerType) {
        case 'year': {
          const yearDate = dayjs().year(this.dateValue);
          startDate = yearDate.startOf('year');
          endDate = yearDate.endOf('year');
          break;
        }
        case 'quarter': {
          const quarterDate = dayjs(this.dateValue).startOf('quarter');
          startDate = quarterDate;
          endDate = quarterDate.add(2, 'month').endOf('month');
          break;
        }
        default:
          if (!this.dateValue || this.dateValue.length === 0) {
            delete this.currentSearchParams.start_date;
            delete this.currentSearchParams.end_date;
            return;
          }
          [startDate, endDate] = this.dateValue.map(date => dayjs(date));
      }

      // Unified parameter setting
      this.currentSearchParams = {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD'),
        search: currentKeywords
      };

      this.query = currentKeywords;
      this.resetVirtualList();
      this.lists = [];
      this.get_orders(0, this.pageSize, this.currentSearchParams);
    },
    check_if_client() {
      return liff.isInClient()
    },

    async exportOrderSummary() {
      const userId = this.userId;
      let startDate = '';
      let endDate = '';

      if (this.date && this.date.length > 0) {
        [startDate, endDate] = this.date.map(date => dayjs(date));
        if (!startDate.isValid() && endDate.isValid()) {
          startDate = endDate;
        } else if (startDate.isValid() && !endDate.isValid()) {
          endDate = startDate;
        } else if (!startDate.isValid() && !endDate.isValid()) {
          // 如果開始日期和結束日期都無效,則使用空字串
          startDate = '';
          endDate = '';
        } else {
          // 格式化日期
          startDate = startDate.format('YYYY-MM-DD');
          endDate = endDate.format('YYYY-MM-DD');
        }
      }

      try {
        let safeNameForUrl = this.name.replace(/[/?%*:|"<>]/g, ' ');

        const response = await fetch(`${api_url}/v1/orders/${userId}/export-order-summary-excel?start_date=${startDate}&end_date=${endDate}&name=${safeNameForUrl}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        const data = await response.json();

        if (data.download_link) {
          // Create a temporary link element
          const link = document.createElement('a');
          link.href = data.download_link;
          
          // Get the file name from the download link
          const fileName = data.download_link.split('/').pop();
          
          // Set the download attribute
          link.setAttribute('download', fileName);
          
          // Append to the DOM
          document.body.appendChild(link);
          
          // Programmatically click the link to trigger the download
          link.click();
          
          // Remove the link when done
          document.body.removeChild(link);
        } else {
          console.error('Download link not found in response');
          return false;
        }
      } catch (error) {
        console.error('匯出訂單失敗', error);
      }
    },

    // triggerFileInput() {
    //   this.showControl(false);
    //   this.$refs.fileInput.click();
    // }, 

    async handleFiles(event) {
      this.url = null;
      this.selectedFile = event.target.files[0];
      this.showCloudUpload(false);

      console.log(this.selectedFile); 

      this.isLoading = true;
      
      try {
        const baseURL = `${api_url}/v1/orders/${this.userId}/upload`;

        const formData = new FormData();
        formData.append('file', this.selectedFile);

        const response = await axios.post(baseURL, formData, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        let errorMessages = ['抱歉', '錯誤', '無法辨識'];

        if (response.data.includes('已經有資料')) {
            this.openModal('confirm');
        } else if (errorMessages.some(msg => response.data.includes(msg))) {
            alert(response.data);
        } else {
            this.selectedFile = null;
        }

      } catch (error) {
        console.error('Error sending GET request:', error);
        // 顯示後端返回的錯誤訊息
        if (error.response && error.response.data) {
          const errorMsg = error.response.data;
          // 檢查是否為額度超限錯誤
          if (typeof errorMsg === 'string' && (errorMsg.includes('超過') || errorMsg.includes('額度') || errorMsg.includes('50'))) {
            this.showQuotaExceededAlert(true);
          } else {
            alert(errorMsg);
          }
        } else if (error.message) {
          alert(`上傳失敗: ${error.message}`);
        }
        return false;
      } finally {
        this.isLoading = false;
        // reset the input value
        this.$refs.fileInput.value = '';
        this.lists = [];
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
        
        // 檔案匯入後檢查是否達到額度限制
        const isFreeUser = !this.subscriptionStatus || 
                          this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        
        if (isFreeUser && this.orderQuota.total_orders >= 50) {
          console.log('檔案匯入後達到 50 筆限制，顯示額度提示...');
          this.showQuotaExceededAlert(true); // 強制顯示，不受 localStorage 限制
        }
      }

    },

    async handleCloudUpload() {
      if (!this.url) {
        alert('請輸入雲端文件連結');
        return;
      }
      this.selectedFile = null;
      this.isLoading = true;
      
      try {
        const baseURL = `${api_url}/v1/orders/${this.userId}/upload_gsheet`;

        const response = await axios.post(baseURL, {}, {
          params: {
            url: this.url
          },
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        if (response.data.includes('已經有資料')) {
          this.openModal('confirm');
        } else if (response.data.includes('抱歉') || response.data.includes('錯誤')) {
          alert(response.data);
        } else {
          this.url = null;
        }

      } catch (error) {
        console.error('Error sendin POST request:', error);
        // 顯示後端返回的錯誤訊息
        if (error.response && error.response.data) {
          const errorMsg = error.response.data;
          // 檢查是否為額度超限錯誤
          if (typeof errorMsg === 'string' && (errorMsg.includes('超過') || errorMsg.includes('額度') || errorMsg.includes('50'))) {
            this.showQuotaExceededAlert(true);
          } else {
            alert(errorMsg);
          }
        } else if (error.message) {
          alert(`上傳失敗: ${error.message}`);
        }
        return false;
      } finally {
        this.isLoading = false;
        this.lists = [];
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
        
        // 雲端匯入後檢查是否達到額度限制
        const isFreeUser = !this.subscriptionStatus || 
                          this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        
        if (isFreeUser && this.orderQuota.total_orders >= 50) {
          console.log('雲端匯入後達到 50 筆限制，顯示額度提示...');
          this.showQuotaExceededAlert(true); // 強制顯示，不受 localStorage 限制
        }
      }
    },

    async handleOverwrite(isYes) {
      let is_remove = null;
      if (isYes) {
        console.log("Yes. Please clear it!");
        is_remove = true;
      } else {
        console.log("No. Don't clear it.");
        is_remove = false;
      }
      let baseURL = '';
      let formData = null;
      if (this.selectedFile) {
        baseURL = `${api_url}/v1/orders/${this.userId}/upload`;
        formData = new FormData();
        formData.append('file', this.selectedFile);
      } else if (this.url) {
        baseURL = `${api_url}/v1/orders/${this.userId}/upload_gsheet`;
        formData = {};
      }

      this.isLoading = true;

      try {
        
        const response = await axios.post(baseURL, formData, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          },
          params: {
            is_remove: is_remove,
            url: this.url
          }
        });

        let dataString;
        if (response.data !== null && response.data !== undefined) {
          dataString = response.data.toString();
        } else {
          dataString = '';
        } 
        if (dataString.includes('抱歉') || dataString.includes('錯誤')) {
          // 檢查是否為額度超限錯誤
          if (dataString.includes('超過') || dataString.includes('額度') || dataString.includes('50')) {
            this.showQuotaExceededAlert(true);
          } else {
            alert(response.data);
          }
        }

      } catch (error) {
        console.error('Error sending POST request:', error);
        return false;
      } finally {
        this.isLoading = false;
        this.lists = [];
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
        this.selectedFile = null;
        this.url = null;
        
        // 覆蓋匯入後檢查是否達到額度限制
        const isFreeUser = !this.subscriptionStatus || 
                          this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        
        if (isFreeUser && this.orderQuota.total_orders >= 50) {
          console.log('覆蓋匯入後達到 50 筆限制，顯示額度提示...');
          this.showQuotaExceededAlert(true); // 強制顯示，不受 localStorage 限制
        }
      }

    },

    removeEmptyValues(obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
          delete obj[key];
        }
      });
      return obj;
    },

    async addOrder(item) {

      this.isLoading = true;

      const baseURL = `${api_url}/v1/orders/${this.userId}/add`;

      try {

        let rawData = JSON.parse(JSON.stringify(item));
        rawData = this.removeEmptyValues(rawData);
        
        await axios.post(baseURL, rawData, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            "ngrok-skip-browser-warning": "69420"
          }
        });

      } catch (error) {
        console.error('Error sending POST request:', error);
        return false;
      } finally {
        this.isLoading = false;
        this.selectedFile = null;
        this.url = null;

        // Reset lists and total items
        this.lists = [];
        this.totalItems = 0;
        
        // Call get_orders with updated parameters
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
        
        // 新增訂單後檢查是否達到額度限制
        const isFreeUser = !this.subscriptionStatus || 
                          this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        
        if (isFreeUser && this.orderQuota.total_orders >= 50) {
          console.log('新增訂單後達到 50 筆限制，顯示額度提示...');
          this.showQuotaExceededAlert(true); // 強制顯示，不受 localStorage 限制
        }
      }
    },

    async updateOrder(item) {
      this.isLoading = true;
      const baseURL = `${api_url}/v1/orders/${this.userId}/update`;

      try {
        let rawData = JSON.parse(JSON.stringify(item));
        rawData = this.removeEmptyValues(rawData);
        
        await axios.post(baseURL, rawData, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            "ngrok-skip-browser-warning": "69420"
          }
        });

        // 更新 this.lists 中的對應項目
        const updatedItemIndex = this.lists.findIndex(order => order.Id === item.Id);
        if (updatedItemIndex !== -1) {
          this.$nextTick(() => {
            // 直接更新對象的屬性
            Object.keys(item).forEach(key => {
              this.lists[updatedItemIndex][key] = item[key];
            });
          });

        }

      } catch (error) {
        console.error('Error sending POST request:', error);
        return false;
      } finally {
        this.isLoading = false;
        this.selectedFile = null;
        this.url = null;
        this.selectedOrder = {};
      }
    },

    async delOrder(id) {
      this.isLoading = true;
      const { userId, token } = this;
      const baseURL = `${api_url}/v1/orders/${userId}/del`;

      try {
        await axios.post(baseURL, {}, {
          params: {
              id: id
          },
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            "ngrok-skip-browser-warning": "69420"
          }
        });

      } catch (error) {
        console.error('Error deleting order:', error);
        // 處理錯誤，例如顯示錯誤消息給用戶
      } finally {
        this.isLoading = false;

        // Reset lists and total items
        this.lists = [];
        this.totalItems = 0;
        
        // Call get_orders with updated parameters
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
      }
    },

    rippleEffect(event) {
      const ripple = document.createElement("div");
      ripple.classList.add('ripple');
      ripple.style.top = event.offsetY + "px";
      ripple.style.left = event.offsetX + "px";
      event.target.appendChild(ripple);
    },

    openModal(type, data, index=-1) {
      if (type == 'order' || type == 'copy'){
        // 檢查是否為未訂閱且超額狀態
        const isFreeUser = !this.subscriptionStatus || 
                          this.subscriptionStatus.main === 'Pending Activation' || 
                          this.subscriptionStatus.main === 'Expired';
        const isQuotaExceeded = this.orderQuota && this.orderQuota.quota_exceeded;
        // 檢查是否已達到或超過 50 筆限制
        const isAtOrOverLimit = isFreeUser && this.orderQuota && this.orderQuota.total_orders >= 50;

        // 純新增操作（非複製）：如果已達到50筆限制，直接攔截並顯示提示
        if (type == 'order' && !data && isFreeUser && isAtOrOverLimit) {
          this.showQuotaExceededAlert(true); // 強制顯示，不受 localStorage 限制
          return;
        }

        this.scrollIndex = index;
        if (this.$refs.virtualListRef) {
          this.scrollOffset = this.$refs.virtualListRef.getOffset();
        }

        if (type == 'copy') {
          // 複製時清除 Id 和 OrderId
          const copiedData = { ...data, Id: '', OrderId: '' };
          Object.assign(this.selectedOrder, copiedData);
          this.orderModalType = 'copy';
        } else if (data) {
          // 更新操作
          Object.assign(this.selectedOrder, data);
          this.orderModalType = 'update';
        } else {
          // 純粹的新增操作
          this.selectedOrder = {};
          this.orderModalType = 'add';
        }

        // 傳遞是否為只讀模式（超過50筆的訂單）
        const isReadOnly = isFreeUser && isQuotaExceeded && index >= 50;
        this.$refs.orderModalRef.openModal(this.orderModalType, this.selectedOrder, isReadOnly);
        this.showControl(false);
      } else if (type == 'uploadFile') {
        this.showCloudUpload(true);
        this.showControl(false);
        this.modalUpload = 'file';
      } else if (type == 'uploadCloud') {
        this.showCloudUpload(true);
        this.showControl(false);
        this.modalUpload = 'cloud';
      } else if (type == 'confirm') {
        this.showConfirm(true);
        this.showControl(false);
      } else if (type == 'del') {
        this.selectedOrder = data;
        this.showDelConfirm(true);
      } else if(type == 'slideDel') {
        this.selectedOrder = data;
        this.slideIndex = index;
        this.showDelConfirm(true);
      } else if (type == 'control') {
        this.showControl(true);
      }
    },

    async closeModal() {
      /* if (this.userId) {
        await this.get_orders();
      } */
      this.selectedOrder = {};
      this.$refs.orderModalRef.closeModal();
      this.showCloudUpload(false);
      this.showConfirm(false);
      this.showDelConfirm(false);
      this.showControl(false);
    },

    // 刪除
    deleteOrder() {
      this.deleteItem(this.selectedOrder, this.slideIndex);
      this.$refs.orderModalRef.closeModal();
    },

    // 滑動刪除
    deleteItem(entry, index) {
      this.restSlide();
      this.lists.splice(index, 1);
      this.delOrder(entry.Id);
    },

    confirmDel() {
      this.showDelConfirm(false);
      this.deleteItem(this.selectedOrder, this.slideIndex);
      this.$refs.orderModalRef.closeModal();
    },

    cancelDel() {
      this.restSlide();
      this.showDelConfirm(false);
      this.selectedOrder = {};
      this.slideIndex = -1;
    },

    restSlide() {
      emitter.emit('restSlide');
    },

    debounceSearch() {
      if (this.debouncedSearch) {
        this.debouncedSearch();
      }
    },

    async handleSearch() {
      if ((this.chips.length !== 0 || (this.query && this.query.trim() !== ''))) {
        this.resetVirtualList();
        
        // Update search parameters while preserving date range
        const { start_date, end_date } = this.currentSearchParams;
        this.currentSearchParams = {
          search: this.query.trim(),
          not_paid: this.chips.includes('notPaid'),
          not_arrived: this.chips.includes('notArrived'),
          ibv: this.chips.includes('ibv'),
          bv: this.chips.includes('bv'),
          ...(start_date && { start_date }),
          ...(end_date && { end_date })
        };
        
        this.lists = [];
        this.totalItems = 0;
        await this.get_orders(0, this.pageSize, this.currentSearchParams);
      }
    },

    clearDate() {
      this.datePickerType='';
      // Reset date picker value
      this.dateValue = null;
      this.selectedDateRange = '（不限時間）';
      this.date = null;

      // Remove date-related search parameters
      delete this.currentSearchParams.start_date;
      delete this.currentSearchParams.end_date;
      
      // Reset lists and reload data
      this.resetVirtualList();
      this.lists = [];
      this.totalItems = 0;
      this.get_orders(0, this.pageSize, this.currentSearchParams);
    },

    clearSearch() {
 
      // Keep date range parameters while clearing others
      const { start_date, end_date } = this.currentSearchParams;
      
      this.isClearing = true;
      this.query = '';
      this.chips = [];
      this.resetVirtualList();
      
      this.currentSearchParams = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date })
      };
      
      this.lists = [];
      this.totalItems = 0;
      
      this.get_orders(0, this.pageSize, this.currentSearchParams);
      this.$nextTick(() => {
        this.isClearing = false;
      });
    },

    checkAndReload() {
      if (!this.isClearing && this.query === '' && this.chips.length === 0 && Object.keys(this.currentSearchParams).length > 0 ) {
        this.clearSearch();
      }
    },

    // search bar chips
    showChips() {
      if (this.chips.length < 4) {
        this.showChipsContainer = true;
      }
    },
    hideChips() {
      setTimeout(() => {
        this.showChipsContainer = false;
      }, 200);  // 延迟隐藏，确保 click 事件能被触发
    },
    addChip(chip) {
      if (!this.chips.includes(chip)) {
        this.chips.push(chip);
        // Preserve date range when adding chip
        const { start_date, end_date } = this.currentSearchParams;
        this.currentSearchParams = {
          search: this.query.trim(),
          not_paid: this.chips.includes('notPaid'),
          not_arrived: this.chips.includes('notArrived'),
          ibv: this.chips.includes('ibv'),
          bv: this.chips.includes('bv'),
          ...(start_date && { start_date }),
          ...(end_date && { end_date })
        };
        this.handleSearch();
      }
    },
    
    closeChip(chip) {
      const index = this.chips.indexOf(chip);
      if (index > -1) {
        this.chips.splice(index, 1);
        // Update search params after removing chip
        const { start_date, end_date } = this.currentSearchParams;
        this.currentSearchParams = {
          search: this.query.trim(),
          not_paid: this.chips.includes('notPaid'),
          not_arrived: this.chips.includes('notArrived'),
          ibv: this.chips.includes('ibv'),
          bv: this.chips.includes('bv'),
          ...(start_date && { start_date }),
          ...(end_date && { end_date })
        };
        this.handleSearch();
      }
    },
    handleKeydown(event) {
      if (event.key === 'Backspace' && this.query === '' && !event.isComposing) {
        this.removeLastChip();
      }
      else if (event.key === 'Enter' && !event.isComposing) {
        this.handleSearch();
      }
    },
    removeLastChip() {
      if (this.chips.length) {
        this.chips.pop();
        this.showChips(); // 删除 chip 后显示 ChipsContainer
      }
    },

    // date picker切換
    getDateFormat() {
      switch(this.datePickerType) {
        case 'year':
          return 'yyyy';
        case 'quarter':
          return 'yyyy-QQ';
        default:
          return 'yyyy/MM/dd';
      }
    },

    // 顯示額度超過提示
    showQuotaExceededAlert(forceShow = false) {
      // 如果不是強制顯示（從 URL 參數觸發），檢查是否已經顯示過
      if (!forceShow) {
        try {
          const uid = this.userId || 'anon';
          const quotaKey = `quota_alert_shown_${uid}`;
          const hasShown = localStorage.getItem(quotaKey);
          
          if (hasShown) {
            // 已顯示過，不再顯示
            // 清除 URL 參數並直接返回
            const newUrl = new URL(window.location);
            newUrl.searchParams.delete('quota_exceeded');
            window.history.replaceState({}, '', newUrl);
            return;
          }
        } catch (e) {
          console.error('Error checking quota alert status:', e);
        }
      }
      
      // 設定額度超過的提示內容
      this.quotaAlertHtml = `
          <h6>📋 訂單額度已滿</h6>
          <p>您的訂單數量已達到免費額度上限（50筆），但您仍可以：</p>
          <ul class="mb-2">
            <li>📄 查看現有訂單</li>
            <li>📤 匯出訂單資料</li>
            <li>🗑️ 刪除不需要的訂單</li>
          </ul>
          <p class="mb-0">如需新增更多訂單，請考慮升級到進階方案。</p>
        `;
      this.shouldShowUpgradeButton = true;
      
      // 使用 Bootstrap Modal 顯示
      this.showQuotaAlertModal(true);
      
      // 只有在非強制顯示時才記錄已顯示（避免每次點擊超額訂單都記錄）
      if (!forceShow) {
        try {
          const uid = this.userId || 'anon';
          const quotaKey = `quota_alert_shown_${uid}`;
          localStorage.setItem(quotaKey, 'true');
        } catch (e) {
          console.error('Error saving quota alert status:', e);
        }
      }
      
      // 清除 URL 中的 quota_exceeded 參數
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete('quota_exceeded');
      window.history.replaceState({}, '', newUrl);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  $spacer: 0.875rem;
  $headerHeight: calc($spacer * 3);
  $primary: #00a8ca;

  #liff {
    overflow-y: auto;
    width: 100%;
    max-width: 640px;
    // min-height: 100vh;

    /* 隐藏滚动条轨道 */
    &::-webkit-scrollbar {
      width: 0;
    }
    /* 隐藏滚动条thumb（滚动条拖动手柄） */
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
      /* 可选：为滚动条thumb添加样式，使其看起来更隐藏 */
      &:hover {
        background-color: transparent;
      }
      &:active {
        background-color: transparent;
      }
    }

    > * {
      width: 100%;
    }
  }

  
  .bottom-92 {
    bottom: 5.75rem;
  }

  .h-header {
    height: $headerHeight;
  }

  main {
    margin: calc($headerHeight * 3) 0 69.5px;
    &.hideTitle {margin: calc($headerHeight * 2) 0 69.5px;}
  }

  footer {
    box-shadow: 0 -.125rem .25rem rgba(black, .075);
    .tab-btn {
      // width: 20%;
      flex: 1; // 使用 flex: 1 讓 tab 自動平分空間
      > * {
        position: relative;
        overflow: hidden;
        &::after {
          content: "";
          position: absolute;
          top:0;
          bottom: 0;
          left: 0;
          right: 0;
          transition: .3s cubic-bezier(.25,.8,.5,1);
          width: 100%;
          // background: rgba(black, .025);
        }
        &.active {
          &::after {background: rgba($primary, .1);}
        }
      }
    }
  }

  // FAB
  $fab: 3.5rem;
  $sub-btn: 3.5rem;
  .fab-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    user-select: none;
    position: absolute;
    bottom: 0; right: 21px;
    &.expanded {
      height: 100%;
      .fab svg {
        transform: rotate(45deg);
      }
      .sub-button {
        transform: translateY(100%) scale(1);
        opacity: 1;
        margin-bottom: 0;
        &:nth-child(2) {
          transform: translateY(-(calc($fab + $spacer)));
          transition-delay: 50ms;
        }
        &:nth-child(3) {
          transform: translateY(-(calc($fab + $spacer*2 + $sub-btn)));
          transition-delay: 100ms;
        }
        &:nth-child(4) {
          transform: translateY(-(calc($fab + $spacer*3 + $sub-btn*2)));
          transition-delay: 150ms;
        }
        &:nth-child(5) {
          transform: translateY(-(calc($fab + $spacer*4 + $sub-btn*3)));
          transition-delay: 200ms;
        }
        &:nth-child(6) {
          transform: translateY(-(calc($fab + $spacer*5 + $sub-btn*4)));
          transition-delay: 250ms;
        }
      }
    }
    .btn {overflow: visible!important;}
    .fab {
      position: relative;
      height: $fab; width: $fab;
      border-radius: 50%;
      z-index: 200;
      transition: all 0.15s ease-in-out;
      box-shadow:
        0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.1),
        0 1px 5px 0 rgba(0, 0, 0, 0.1);
      .fab-content {
        display: flex;
        align-items: center; justify-content: center;
        height: 100%; width: 100%;
        border-radius: 50%;
        > svg {
          transition: transform 0.15s ease-in-out;
        }
      }
      &:hover {
        box-shadow:
          0 3px 5px -1px rgba(0, 0, 0, 0.2),
          0 6px 10px 0 rgba(0, 0, 0, 0.1),
          0 1px 18px 0 rgba(0, 0, 0, 0.1);
      }
    }
    .sub-button {
      z-index: 100;
      position: absolute;
      display: flex;
      align-items: center; justify-content: center;
      bottom: 0;
      margin-bottom: .5rem;
      height: $sub-btn; width: $sub-btn;
      border-radius: 50%;
      transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1),
                  opacity .65s cubic-bezier(.14,.55,.42,.92);
      transform: translateY(20px) scale(0.3);
      opacity: 0;
      box-shadow:
        0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.1),
        0 1px 5px 0 rgba(0, 0, 0, 0.1);
      &:hover {
        cursor: pointer;
        box-shadow:
          0 3px 5px -1px rgba(0, 0, 0, 0.2),
          0 6px 10px 0 rgba(0, 0, 0, 0.1),
          0 1px 18px 0 rgba(0, 0, 0, 0.1);
      }
      .btn-content {
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: - calc($spacer * 5.5);
          transform: translateY(-50%);
          width:calc($spacer * 5);
          color: white;
          font-size: $spacer;
          font-weight: 500;
          display:flex;
          align-items: center;
          justify-content: end;
          cursor: pointer;
          transition: .3s cubic-bezier(.25,.8,.5,1);
        }
        &.a::before {content: "單筆新增";}
        &.b::before {content: "從檔案匯入";}
        &.c::before {content: "從雲端匯入";}
      }
    }
  }

  .modal-dialog-control {
    @media (min-width: 576px) {
      max-width:640px;
    }
    position: fixed;
    inset:auto 0 0 0;
    .modal-content {
      border-radius: 1rem 1rem 0 0;
      padding: 2rem 1rem 3rem;
    }
  }

  .search,.date-form {
    background: rgba(black, .035);
    position: relative;
    height: 38px;
    padding: 0 2rem;
    border-radius: 0 0.375rem 0.375rem 0;
    .search-input {
      font-size: 0.875rem;
      padding: 0 .2rem;
      border: 0;
      border-radius: 0;
      background: transparent;
      &:focus {
        box-shadow: none;
      }
      &::placeholder {
        color: #9b9b9b;
      }
    }
    .search-icon, .close-icon {
      position: absolute;
      top: 0;
      height: 100%; width: 2rem;
      display: flex;
      align-items: center; justify-content: center;
    }
    .search-icon {
      left: 0;
    }
    .close-icon {
      right: 0;
      cursor: pointer;
    }
  }
  .date-form {
    padding:0 2rem 0 0;
  }
  // date picker
  .dateTrigger {
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 9px;
  }
  .dp__main {
    height: 38px; width: auto;
    display: flex;
    align-items: center;
    justify-content: start;
    white-space: nowrap;
    border: #c4c8cb 1px solid;
    border-width: 1px 0 1px 1px;
    border-radius: 0.375rem 0 0 0.375rem;
    background: white;
    cursor: pointer;
    .btn {
      padding: 6px 10px;
    }
  }


  //transition
  .v-enter-active, .v-leave-active {
    transition: opacity 0.15s linear;
  }

  .v-enter-from, .v-leave-to {
    opacity: 0;
  }

  .v-enter-to, .v-leave-from {
    opacity: 1;
  }


  .chips {
    padding: .625rem .75rem;
    & > small {
      font-weight: 600;
      padding: .125rem .625rem;
      & + small {
        margin-left: .5rem;
      }
    }
  }
  .top-101 {
    top: calc(100% + .375rem);
  }

  .btn-pagin {
    width: 2rem; height: 2rem;
  }

  // 額度顯示樣式
  .quota-badge {
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 0.75rem;
    line-height: 1.2;
  }

  .new {
    font-size: 0.6rem;
    width: 32px;
    height: 16px;
    top: -34px;
    right: -24px;
  }
</style>
